export function noop(): void {
  return;
}
